import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProductCard from "../ProductCard/ProductCard";

const BestDeals = ({ emptyState = null }) => {
  const [data, setData] = useState([]);
  const { allProducts } = useSelector((state) => state.products);

  useEffect(() => {
    const allProductsData = allProducts ? [...allProducts] : [];
    const sortedData = allProductsData?.sort((a, b) => b.sold_out - a.sold_out);
    const firstFive = sortedData && sortedData.slice(0, 5);
    setData(firstFive);
  }, [allProducts]);

  return (
    <div className="best-deals-homepage-container">
      <div className="best-deals-homepage-section">
        <div className="best-deals-homepage-heading">
          <h1>Best Deals</h1>
        </div>
        <div className="best-deals-homepage-grid">
          {data && data.length !== 0 ? (
            <>
              {data.map((i, index) => (
                <ProductCard data={i} key={index} />
              ))}
            </>
          ) : (
            emptyState
          )}
        </div>
      </div>
    </div>
  );
};

export default BestDeals;

